// src/settings.js
const API_URL = 'https://backend-health-care-su.avasoft.fyi' ///'https://health-db-json.onrender.com'//Default API URL 'http://localhost:3000'; // 

export default API_URL;